import { useI18next, useTranslation } from 'gatsby-plugin-react-i18next';
import React, { ReactNode } from 'react';
import { secondHandMachinesContentLoader } from '../../utils/secondHandMachinesContentLoader';
import Persons from '../Page/ContentTypes/Persons/Persons';
import SecondHandMachinesAccordion from './SecondHandMachinesAccordion/SecondHandMachinesAccordion';
import {
    InformationNote,
    InformationNoteText,
    InformationWrapper,
    PersonHeadline,
    PersonWrapper,
    SecondHandMachinesContainer,
    SecondHandMachinesSectionBox,
    SecondHandMachinesSectionSubtitle,
    SecondHandMachinesSectionTitle,
    SecondHandMachinesTextSection,
    SecondHandMachinesTitle,
} from './SecondHandMachinesPageStyle';
import { personData, sectionsData } from '../../constants/secondHandMachinesPageSectionsData';

const SecondHandMachinesPage = ({ usedMachinesData }) => {
    const { t } = useTranslation();
    const { language } = useI18next();
    const { instructionText, instructionListElement, pleaseNoteText } = secondHandMachinesContentLoader(language);

    const formatStaticTableData = (dataToFormat: any): any => {
        const data = JSON.parse(dataToFormat);
        return data?.others?.items;
    };

    const filterDataByCategory = (category: string): Array<any> | null => {
        if (usedMachinesData !== null) {
            const dataJson = JSON.parse(usedMachinesData);
            const filterData = dataJson?.items?.filter((item: any) => item?.Type === category);
            return filterData;
        }
        return null;
    };

    const sectionValues = (item: any): any => {
        return item.sectionAccordionItems
            .filter((item: any) => {
                const data = filterDataByCategory(item.value);
                return data?.length > 0;
            })
            .map((item: any, index: number) => (
                <SecondHandMachinesAccordion
                    key={item.title + index}
                    title={item.title}
                    tableData={filterDataByCategory(item.value)}
                />
            ));
    };

    const displaySections = (): ReactNode =>
        sectionsData.map((item: any, index: number) => {
            const values = sectionValues(item);
            if (Array.isArray(values) && values.length > 0) {
                return (
                    <SecondHandMachinesSectionBox key={item.sectionTitle + index}>
                        <SecondHandMachinesSectionTitle>{t(item.sectionTitle)}</SecondHandMachinesSectionTitle>
                        {item.sectionText !== null && (
                            <SecondHandMachinesTextSection>{t(item.sectionText)}</SecondHandMachinesTextSection>
                        )}
                        {values}
                    </SecondHandMachinesSectionBox>
                );
            } else {
                return '';
            }
        });

    return (
        <SecondHandMachinesContainer>
            <SecondHandMachinesTitle>{t('secondHandMachinesTitle')}</SecondHandMachinesTitle>
            <SecondHandMachinesTextSection>{t('secondHandMachinesDescriptionText')}</SecondHandMachinesTextSection>
            {displaySections()}
            <SecondHandMachinesSectionSubtitle>{t('futureAvailableComponents')}</SecondHandMachinesSectionSubtitle>
            <SecondHandMachinesAccordion
                title={t('others')}
                unSortableTableData={formatStaticTableData(usedMachinesData)}
            />
            <SecondHandMachinesSectionSubtitle>{t('offerUsYourSecondHandMachine')}</SecondHandMachinesSectionSubtitle>
            <SecondHandMachinesAccordion
                title={t('instructions')}
                instructionText={instructionText}
                instructionListElements={instructionListElement}
            />
            <PersonWrapper>
                <PersonHeadline>{t('contact')}</PersonHeadline>
                <Persons item={personData} />
            </PersonWrapper>
            <InformationWrapper>
                <InformationNote>{t('pleaseNote')}</InformationNote>
                <InformationNoteText dangerouslySetInnerHTML={{ __html: pleaseNoteText }}></InformationNoteText>
            </InformationWrapper>
        </SecondHandMachinesContainer>
    );
};

export default SecondHandMachinesPage;
